module.exports = __webpack_public_path__ + "img/mini-021.970c5bd8.jpg";